/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:36:21
 * @Description: file content
 */
import React, { Component } from 'react';
import OriginTooltip from 'bee-tooltip';
import { getSysFieldid } from '@platform/api';

require('bee-tooltip/build/Tooltip.css');
require('./index.less');

export default class Tooltip extends Component {
	render() {
		let { fieldid, className, ...others } = this.props;
		return <OriginTooltip inverse className={`${className + ' nc-tooltip'}`} {...others} fieldid={getSysFieldid(fieldid)} />;
	}
}
